import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import ProductInformation from './components/ProductInformation';
import ProductPrice from './components/ProductPrice';
import AdditionalInformation from './components/AdditionalInformation';
import OtherInformation from './components/OtherInformation';
import * as CommonService from '../../../services/CommonService';

import { PRODUCT_ENDPOINT } from '../../../services/endpoint';
import { Button, Col, message, Modal, Row } from 'antd';

export default () => {

	const { id } = useParams();

	const history = useHistory();

	const [product, setProduct] = useState({});

	useEffect(() => {
		const init = async () => {
			window.setLoading(true);
			const resp = await CommonService.findById(PRODUCT_ENDPOINT, id);
			setProduct(resp.data || {});
			window.setLoading(false);
		};
		init();
	}, []);

	const back = () => {
		history.push('/product');
	};

	const gotoEdit = (id) => {
		history.push('/product/edit/' + id);
	};

	const handleDelete = (id) => {
		window.setLoading(true);
		CommonService.deleteRecord(PRODUCT_ENDPOINT, id).then(() => {
			back();
			message.success('Xóa sản phẩm thành công');
		}).catch(err => {
			message.error(err?.data?.message);
		}).finally(() => {
			window.setLoading(false);
		});
	};

	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = () => {
		setIsModalOpen(true);
	};
	const handleOk = () => {
		setIsModalOpen(false);
		handleDelete(id);
	};
	const handleCancel = () => {
		setIsModalOpen(false);
	};

	return <div id={'product-detail-page'}>
		<h2 style={{color: '#1890ff'}}> {product.name}</h2>
		<Row gutter={12}>
			<Col>
				<ProductInformation product={product} showModal={showModal} gotoEdit={gotoEdit} />
			</Col>
			<br />
			<Col sm={24} md={16}>
				<ProductPrice product={product} />
			</Col>
			<Col sm={24} md={8}>
				<AdditionalInformation product={product} />
			</Col>
			<Col sm={24} md={24}>
				<OtherInformation product={product} />
			</Col>
		</Row>
		<Col style={{ textAlign: 'right', marginTop: 10 }}>
			<Button style={{ marginRight: '5px' }} onClick={() => history.push('/product')}>Thoát</Button>
		</Col>
		<Modal
			title="Xóa sản phẩm"
			visible={isModalOpen}
			onOk={handleOk}
			onCancel={handleCancel}
		>
			<p>Bạn có chắc chắn muốn xóa sản phẩm <b>{product.name}</b>? Thao tác này không thể khôi phục.</p>
		</Modal>
	</div>;
}
